// src/pages/Cart.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function Cart() {
  const { cartItems, removeFromCart, totalPrice, clearCart } = useCart();

  return (
    <div style={{ maxWidth: '1200px', margin: '2rem auto', padding: '0 1rem' }}>
      <h2>My Cart</h2>

      {cartItems.length === 0 ? (
        <p>Your cart is empty. Go select some repairs!</p>
      ) : (
        <>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {cartItems.map((item, idx) => (
              <li
                key={`${item.id}-${idx}`}
                style={{
                  border: '1px solid #ddd',
                  padding: '1rem',
                  marginBottom: '1rem',
                  borderRadius: '8px',
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '1rem'
                }}>
                  <div style={{ flex: '1', minWidth: '200px' }}>
                    <strong style={{ fontSize: '16px' }}>{item.name}</strong>
                    {/* Show selected screen type if available */}
                    {item.selectedScreenType && (
                      <div style={{ marginTop: '0.5rem', fontSize: '14px', color: '#6c757d' }}>
                        Screen Type: {item.selectedScreenType}
                      </div>
                    )}
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                    flexWrap: 'wrap'
                  }}>
                    <span style={{
                      fontSize: '18px',
                      fontWeight: 'bold',
                      color: '#007BFF'
                    }}>
                      £{item.cost.toFixed(2)}
                    </span>
                    <button
                      onClick={() => removeFromCart(item.id)}
                      style={{
                        background: '#dc3545',
                        color: '#fff',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px'
                      }}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          <div style={{
            borderTop: '2px solid #ddd',
            paddingTop: '1rem',
            marginTop: '1rem'
          }}>
            <h3 style={{ fontSize: '24px', color: '#007BFF' }}>
              Total: £{totalPrice.toFixed(2)}
            </h3>
          </div>

          <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <button
              onClick={clearCart}
              style={{
                background: '#6c757d',
                color: '#fff',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              Clear Cart
            </button>

            {/* "Book a Repair" leads to booking page */}
            <Link
              to="/booking"
              style={{
                display: 'inline-block',
                background: '#007BFF',
                color: '#fff',
                padding: '12px 24px',
                textDecoration: 'none',
                borderRadius: '4px',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              Book a Repair
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

export default Cart;
